import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import SectionHeading from "./SectionHeading";

const faqs = [
  {
    q: "Is Vaulzo free to start?",
    a: "Yes. Create an account and begin adding assets and liabilities — no credit card required to get going.",
  },
  {
    q: "Where is my data stored?",
    a: "Your account is backed by a secure database; only you can access your portfolio after signing in.",
  },
  {
    q: "Can I track foreign currency or travel points?",
    a: "Yes. You can record foreign amounts and travel-points style assets, with FX context where the app supports it.",
  },
  {
    q: "How often is net worth updated?",
    a: "Your dashboard reflects what you enter; scheduled snapshots help build a history for charts over time.",
  },
];

/**
 * FAQ accordion restyled with Vaulzo hairlines and type. Uses the
 * shadcn Accordion for behavior; only the visuals are overridden.
 */
export default function LandingFAQ() {
  return (
    <section
      id="faq"
      className="scroll-mt-24 border-t border-vaulzo-hairline py-16 sm:py-24"
    >
      <div className="mx-auto max-w-[640px] px-6">
        <SectionHeading
          eyebrow="FAQ"
          title="Questions"
          subtitle="Quick answers — reach out if you need more detail."
        />

        <Accordion type="single" collapsible className="mt-10 w-full">
          {faqs.map((item, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-vaulzo-hairline">
              <AccordionTrigger className="text-left text-[15px] font-medium text-vaulzo-ink hover:no-underline">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm leading-relaxed text-vaulzo-faint">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
